import { post } from "@/utils/utils";
import moment from "moment";
 
const stroreAndStaff = {
  state: {
    storeList: {
      total: 0,
      list: []
    },
    editStoreCode: "",
    addStoreCode: "",
    deleteStoreCode: "",
    serviceList: {
      total: 0,
      list: []
    },
    addServiceCode: "",
    editServiceCode: "",
    copyServiceCode: "",
    deleteServiceCode: "",
    staffList: {
      total: 0,
      list: []
    },
    addStaffCode: "",
    editStaffCode: "",
    deleteStaffCode: "",
    schedulingList: {
      total: 0,
      list: []
    },
    addSchedulingCode: "",
    editSchedulingCode: "",
    deleteSchedulingCode: "",
    rowService: {},
    editSchedulingListCode: "",
    guiderWorkTimeList: [],
    disabledSchedulingList: [],
    serviceCategoryList: []
  },
  mutations: {
    STORE_LIST(state, data) {
      state.storeList = data.result;
      state.storeList.list.forEach(v => {
        v.createTimeFormat = moment(v.createTime).format("YYYY-MM-DD HH:mm:ss");
      });
    },
    ADD_STORE(state, data) {
      state.addStoreCode = data.result;
    },
    EDIT_STORE(state, data) {
      state.editStoreCode = data.result;
    },
    DELETE_STORE(state, data) {
      state.deleteStoreCode = data.result;
    },
    SERVICE_LIST(state, data) {
      state.serviceList = data.result;
      // state.serviceList.list.forEach(v => {
      //   v.serverTagsFormat = v.serverTags.join(",");
      //   // v.validateStartDateFormat = v.validateStartDate
      //   //   ? moment(v.validateStartDate).format("YYYY-MM-DD")
      //   //   : "";
      //   // v.validateEndDateFormat = v.validateEndDate
      //   //   ? moment(v.validateEndDate).format("YYYY-MM-DD")
      //   //   : "";
      // });
    },
    ADD_SERVICE(state, data) {
      state.addServiceCode = data.result;
    },
    EDIT_SERVICE(state, data) {
      state.editServiceCode = data.result;
    },
    COPY_SERVICE(state, data) {
      state.copyServiceCode = data.result;
    },
    DELETE_SERVICE(state, data) {
      state.deleteServiceCode = data.result;
    },
    STAFF_LIST(state, data) {
      if (data.result.list) {
        data.result.list.forEach(item => {
          item.serviceList = [];
          if (item.serverId) {
            const serverStatusList = item.serverStatus
              ? item.serverStatus.split(",")
              : [];
            item.serverId.split(",").forEach((v, i) => {
              item.serviceList.push({
                name: item.serverName.split(",")[i],
                id: v,
                type: serverStatusList[i] || ""
              });
            });
          }
          item.serviceList.forEach(v => {
            v.typeFormat = v.type === "0" ? "关闭" : "";
          });
        });
      }
      state.staffList = data.result;
    },
    RESET_STAFF_LIST(state) {
      state.staffList = [];
    },
    ADD_STAFF(state, data) {
      state.addStaffCode = data.result;
    },
    EDIT_STAFF(state, data) {
      state.editStaffCode = data.result;
    },
    DELETE_STAFF(state, data) {
      state.deleteStaffCode = data.result;
    },
    SCHEDULING_LIST(state, data) {
      if (data.result && data.result.list) {
        data.result.list.forEach(v => {
          v.serverNameList = [];
          v.ruleList.forEach(item => {
            v.serverNameList.push(item.serverName);
          });
        });
      }
      state.schedulingList = data.result;
    },
    EDIT_SCHEDULING_LIST(state, data) {
      state.editSchedulingListCode = data.result;
    },
    ADD_SCHEDULING(state, data) {
      state.addSchedulingCode = data.result;
    },
    EDIT_SCHEDULING(state, data) {
      state.editSchedulingCode = data.result;
    },
    DELETE_SCHEDULING(state, data) {
      state.deleteSchedulingCode = data.result;
    },
    ROW_SERVICE(state, data) {
      state.rowService = data.result;
    },
    QUERY_GUIDER_WORK_TIME(state, data) {
      state.guiderWorkTimeList = data.result;
    },
    DISABLED_SCHEDULING_LIST(state, data) {
      state.disabledSchedulingList = data.result;
    },
    ADD_SERVICE_CATEGORY(state, data) {
      state.addServiceCategoryCode = data.result;
    },
    QUERY_SERVICE_CATEGORY_LIST(state, data) {
      state.serviceCategoryList = data.result;
    },
    EDIT_SERVICE_CATEGORY(state, data) {
      state.editServiceCategoryCode = data.result;
    },
    DELETE_SERVICE_CATEGORY(state, data) {
      state.deleteServiceCategoryCode = data.result;
    }
  },
  actions: {
    addServiceCategory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_service_category`,
        name: "ADD_SERVICE_CATEGORY",
        params
      });
    },
    editServiceCategory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_service_category`,
        name: "EDIT_SERVICE_CATEGORY",
        params
      });
    },
    deleteServiceCategory({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_service_category`,
        name: "DELETE_SERVICE_CATEGORY",
        params
      });
    },
    queryServiceCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/service_category_list`,
        name: "QUERY_SERVICE_CATEGORY_LIST",
        params
      });
    },
    queryServiceList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_info_list`,
        name: "SERVICE_LIST",
        params
      });
    },
    queryRowService({ commit }, params) {
      return post({
        commit,
        url: `/server-back/server_detail`,
        name: "ROW_SERVICE",
        params
      });
    },
    addStore({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_store_outlet`,
        name: "ADD_STORE",
        params
      });
    },
    editStore({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_store_outlet`,
        name: "EDIT_STORE",
        params
      });
    },
    deleteStore({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_store_outlet`,
        name: "DELETE_STORE",
        params
      });
    },
    queryStoreList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/store_outlet_list`,
        name: "STORE_LIST",
        params
      });
    },
    addService({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_server`,
        name: "ADD_SERVICE",
        params
      });
    },
    editService({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_server`,
        name: "EDIT_SERVICE",
        params
      });
    },
    copyService({ commit }, params) {
      return post({
        commit,
        url: `/server-back/copy_server`,
        name: "COPY_SERVICE",
        params
      });
    },
    deleteService({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_server`,
        name: "DELETE_SERVICE",
        params
      });
    },
    queryStaffList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/guider_list`,
        name: "STAFF_LIST",
        params
      });
    },
    addStaff({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_guider`,
        name: "ADD_SERVICE",
        params
      });
    },
    editStaff({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_guider`,
        name: "EDIT_STAFF",
        params
      });
    },
    deleteStaff({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_guider`,
        name: "DELETE_STAFF",
        params
      });
    },
    querySchedulingList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/guider_task`,
        name: "SCHEDULING_LIST",
        params
      });
    },
    queryDisabledScheduling({ commit }, params) {
      return post({
        commit,
        url: `/server-back/guider_task_repeat`,
        name: "DISABLED_SCHEDULING_LIST",
        params
      });
    },
    queryGuiderWorkTime({ commit }, params) {
      return post({
        commit,
        url: `/server-back/into_guider_task`,
        name: "QUERY_GUIDER_WORK_TIME",
        params
      });
    },
    editSchedulingList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/edit_guider_task`,
        name: "EDIT_SCHEDULING_LIST",
        params
      });
    },
    addScheduling({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_guider_task`,
        name: "ADD_SCHEDULING",
        params
      });
    },
    editScheduling({ commit }, params) {
      return post({
        commit,
        url: `/server-back/update_guider_task`,
        name: "EDIT_SCHEDULING",
        params
      });
    },
    deleteScheduling({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_guider_task`,
        name: "DELETE_SCHEDULING",
        params
      });
    }
  }
};

export default stroreAndStaff;
